import { PaymentsService } from "./implementations/payments.service.js";
import { useStore } from "vuex";

export default defineNuxtPlugin((nuxtApp) => {
  const payments = new PaymentsService(
    nuxtApp.$axios,
    nuxtApp.$services,
    useStore(),
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      payments: payments,
    },
  };
});
